import { render } from "./IndexMenuItems.vue?vue&type=template&id=27ff7c7e"
import script from "./IndexMenuItems.vue?vue&type=script&lang=js"
export * from "./IndexMenuItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__